import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPageAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPageAdd"><Path d="M4 2V22H16V20.5H13V16H16V13H20V2H4Z" fill="currentColor"/><Path d="M22 17.5H19V14.5H17.5V17.5H14.5V19H17.5V22H19V19H22V17.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPageAdd;
